import type { FaireProductEntity } from "../../entity_types/product";

export const fable_home_6: FaireProductEntity = {
  token: "fable-home-6",
  type: "product",
  name: "Linen Table Runner",
  brandName: "Fable Home",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  priceDollars: 72,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  weight: 1.2,
  dimensions: {
    width: 72,
    height: 14,
    depth: 1,
  },
  description: "Elegant linen table runner for special occasions.",
  categoryTokens: ["cat_accessories"],
  tags: ["linen", "table", "runner"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
